import React, { useEffect, useState } from "react";

import { View_icon } from "../../../assets/img";

import { Table } from "../../../Component/Table/Table";
import { Toast } from "../../../Component/Toast";
import { URLS } from "../../../Services/Constant";
import { get, post } from "../../../Services/ApiHandler";
import useStoreKv from "../../redux/store/useStorekv";
import CustomScroll from "../../../Component/CustomScroll";

const BlockedClient = () => {


  const { kv, set } = useStoreKv();
  const blockedClient = kv.blockedclient || [];


  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState(1);
  const [loader, setLoader] = useState(false);

  const [popup, setPopup] = useState(false);
  const [Reason, setReason] = useState(false);
  const [selectedReason, setSelectedReason] = useState("");
  const [loading, setLoading] = useState(false);
  const [idd, setIdd] = useState(null);

  const [owners, setOwners] = useState(blockedClient);

  const getList = async () => {
    try {
      if (!kv.blockedclient || kv.blockedclient.length === 0) {
        setLoading(true);
      }
      const res = await get(`${URLS.BLOCKEDCLIENT}`);
//       console.log("Fetched data:", res);

      if (res?.status === "success" && res?.data) {
        setOwners(res?.data);
        set("blockedclient", res?.data);
      } else {
        setOwners([]);
        set("blockedclient", []);
      }
    } catch (err) {
      Toast("Failed to load");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getList();
  }, []);

  const handleUnblock = async () => {


    try {
      setLoader(true);
      const res = await post(`${URLS.CLIENT}/${idd}/unblock`);

//       console.log("unblock success:", res);

      if (res?.status === "success") {
        setPopup(false);

        getList();
      } else {
        console.error("Failed to change block status:", res);
      }
    } catch (err) {
      console.error("Error during unblock:", err);
    } finally {
      setLoader(false);
    }
  };



  const columns = React.useMemo(
    () => [
      {
        id: "client_id",
        Header: () => (
          <div style={{ textAlign: "center" }}>
            Client <br /> ID
          </div>
        ),
        accessor: "client_id",
        Cell: ({ value }) => <p className="ac-text text-center">{value}</p>,
      },
      {
        id: "mobile",
        Header: " Mobile No",
        accessor: "mobile",
        Cell: ({ value }) => <p className="ac-text text-center">{value}</p>,
      },
      {
        Header: "Reasons",
        accessor: "block_reason",
        Cell: ({ value }) => {
          return (
            <div className="d-flex ac-jc gap-1">
              <p
                style={{
                  maxWidth: "50px",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {value}
              </p>

              <button
                onClick={() => {
                  setSelectedReason(value);
                  setReason(true);
                }}
                className="cust-btn"
              >
                <img src={View_icon} height={15} alt="" className="view-btn" />
              </button>
            </div>
          );
        },
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ row }) => {
          return (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: 2,
              }}
            >
              {row.original.role !== "Super Admin" && (
                <button
                  onClick={() => {
                    setIdd(row.original?.client_id);
                    setPopup(true);
                  }}
                  className="active-btn border-0 fs-sm-10 fs-md-12 f2 fs-lg-14 fs-xl-13"
                >
                  Unblock
                </button>
              )}
            </div>
          );
        },
      },
    ],
    []
  );

  return (
    <div className="dashRightView ">
      <CustomScroll>
        <div className="container_overalls">
          <Table
            columns={columns}
            setPageno={setPage}
            pagecount={pagination}
            data={owners}
            show={false}
            loading={loading}
          />
        </div>
      </CustomScroll>
      {/* UNBLOCK CONFIRM POPUP */}
      {popup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p className="f3 fs-xs-16 fs-sm-15 fs-md-15 fs-lg-15 fs-xl-17 fs-xxl-19 primary">
              Are you sure, you want to Unblock ?
            </p>

            <div style={{ paddingTop: 20 }} className="d-flex ac-jb px-2 f3 fs-xs-14 fs-sm-15 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19">
              <button onClick={() => setPopup(false)} className="no-btn f4 w-45">
                Close
              </button>

              <button
                onClick={handleUnblock}
                className="yes-btn f2 w-45 f3 fs-xs-14 fs-sm-15 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19"
              >
                {loader ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                      style={{ color: "white", padding: 8 }}
                    ></span>
                  </>
                ) : (
                  <span style={{ top: -1.5, position: 'relative' }}>Confirm</span>
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* VIEW REASON POPUP */}
      {Reason && (
        <div onClick={() => setReason(false)} className="img-popup-design3">
          <div className="img-popup3">
            <button className="close-btn" onClick={() => setReason(false)}>
              ×
            </button>

            <h4 className="f3 fs-xs-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 announement_title2">
              Message
            </h4>

            <div className="messageShow">
              <p className="f2 fs-xs-16">{selectedReason}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BlockedClient;
